/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

var FORM_CONTROL_COMPONENTS = ["TInput", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];

export { FORM_CONTROL_COMPONENTS };
//# sourceMappingURL=const.js.map
